import resolveConfig from 'tailwindcss/resolveConfig';

// eslint-disable-next-line import/extensions
import tailwindConfig from '../tailwind.config.js';

const fullConfig = resolveConfig(tailwindConfig);

export const getBreakpoints = () => {
  return Object.fromEntries(
    Object.entries(fullConfig.theme?.screens ?? {}).map(([key, value]) => [
      key,
      parseInt((value as string).replace('px', ''), 10),
    ])
  );
};
